import { mcaindia, msme, startupindia } from "../assets";

const HomeMadeInIndia = () => (
  <section style={{ padding: "0 16px 48px" }} aria-labelledby="mh-india-h">
    <div className="mh-india">
      <div>
        <div className="mh-flag" aria-hidden="true">
          <i style={{ background: "#ff9933" }} />
          <i style={{ background: "#e4ebf3" }} />
          <i style={{ background: "#138808" }} />
        </div>
        <h2 id="mh-india-h">Proudly Made in India</h2>
        <p>Built for Indian property, in your language. Your data stays safe in India.</p>
      </div>
      <div className="mh-logos">
        <img className="sm" src={startupindia} alt="Startup India" loading="lazy" width={171} height={44} />
        <i aria-hidden="true" />
        <img src={msme} alt="Ministry of MSME, Government of India" loading="lazy" width={105} height={58} />
        <i aria-hidden="true" />
        <img src={mcaindia} alt="Ministry of Corporate Affairs, Government of India" loading="lazy" width={85} height={46} />
      </div>
    </div>
  </section>
);

export default HomeMadeInIndia;
